import env from '@polleverywhere/core/lib/env'
import Experiment from '@polleverywhere/experiment'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../slices/app'

class ExperimentHelper {
  // Extra properties to send when determining segment
  get properties () {
    const isIos = window.Capacitor?.platform === 'ios'
    const role = store.getState()[appSlice.name].role
    return {
      src: `${role + (isIos ? ':ios' : '')}`
    }
  }

  setup (visitorId) {
    this.experiment = new Experiment(env.get('api_url'), {
      visitorId
    })
    // Cache of known experiment segments for this visitor
    this.segments = {}
  }

  async segmentFor (name) {
    // No segment if not setup (e.g. when tracking not allowed)
    if (!this.experiment) {
      return
    }

    // Fetch the segment for this experiment if it's not already cached
    if (!this.segments[name]) {
      try {
        this.segments[name] = await this.experiment.segment({
          experiment: name,
          properties: this.properties
        })
      } catch (e) {
        // Fail safely to undefined, but log a warning
        console.warn(`Unable to load segment for ${name}`)
      }
    }

    return this.segments[name]
  }
}

export const experimentHelper = new ExperimentHelper()
